import { formatDate } from "@angular/common";
import { environment } from "src/environments/environment";
import { CandidatesProfiles } from './candidatesProfiles.model';
import { Jobs } from './jobs.model';

export class Candidates {
  private id: number;
  private typeCandidate: string;
  private gender: string;
  private firstName: string;
  private lastName: string;
  private email: string;
  private dateBirth: Date;
  private profil: string;
  private phone1: string;
  private phone2: string;
  private cvPath: string;
  private idCard: string;
  private city: string;
  private country: string;
  private maritalStatus: string;
  private photo: string;
  private videoPresentation: string;
  private tempWorker: any;
  private driverLicence: any;
  private passport: any;
  private token: string;
  private dateCreate: Date;
  private dateUpdate: Date;
  private isDelete: boolean;
  private candidatesProfiles: any[];;
  private candidatesTrainings: any[];
  private candidatesLanguages: any[];
  private candidatesSkills: any[];
  private candidatesCertificates: any[];
  private candidatesExperiences: any[];
  private candidatesJobsAlerts: any[];
  private candidatesJobsApply: any[];
  private candidatesEducationsAlerts: any[];
  private candidatesSaveJobs: Jobs[];

  constructor(candidatesModel: any) {
    this.id = candidatesModel.id;
    this.typeCandidate = candidatesModel.typeCandidate;
    this.gender = candidatesModel.gender;
    this.firstName = candidatesModel.firstName;
    this.lastName = candidatesModel.lastName;
    this.profil = candidatesModel.profil;
    this.email = candidatesModel.email;
    this.dateBirth = candidatesModel.dateBirth;
    this.phone1 = candidatesModel.phone1;
    this.phone2 = candidatesModel.phone2;
    this.cvPath = candidatesModel.cvPath;
    this.idCard = candidatesModel.idCard;
    this.city = candidatesModel.city;
    this.country = candidatesModel.country;
    this.maritalStatus = candidatesModel.maritalStatus;
    this.photo = candidatesModel.photo;
    this.videoPresentation = candidatesModel.videoPresentation;
    this.tempWorker = candidatesModel.tempWorker;
    this.driverLicence = candidatesModel.driverLicence;
    this.passport = candidatesModel.passport;
    this.token = candidatesModel.token;
    this.dateCreate = candidatesModel.dateCreate;
    this.dateUpdate = candidatesModel.dateUpdate;
    this.isDelete = candidatesModel.isDelete;
    this.candidatesProfiles = candidatesModel.candidatesProfiles;
    this.candidatesTrainings = candidatesModel.candidatesTrainings;
    this.candidatesLanguages = candidatesModel.candidatesLanguages;
    this.candidatesSkills = candidatesModel.candidatesSkills;
    this.candidatesCertificates = candidatesModel.candidatesCertificates;
    this.candidatesExperiences = candidatesModel.candidatesExperiences;
    this.candidatesJobsAlerts = candidatesModel.candidatesJobsAlerts;
    this.candidatesJobsApply = candidatesModel.candidatesJobsApply;
    this.candidatesEducationsAlerts = candidatesModel.candidatesEducationsAlerts;
    this.candidatesSaveJobs = candidatesModel.candidatesSaveJobs;
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    const name = this.firstName + ' ' + this.lastName;
    let username = '';

    if (name.length > 23) {
      for (let index = 0; index < 10; index++) {
        const element = name[index];
        username += element;
      }
      username += ' ...';
    } else {
      username = this.firstName + ' ' + this.lastName;
    }

    return username;
  }

  public getTypeCandidate(): string {
    return this.typeCandidate;
  }

  public getGender(): string {
    return this.gender;
  }
  public getProfil(): string {
    return this.profil;
  }

  public getFirstName(): string {
    return this.firstName;
  }

  public getLastName(): string {
    return this.lastName;
  }

  public getEmail(): string {
    return this.email;
  }

  public getDateBirth(): String {
    if (this.dateBirth == null) {
      return '';
    } else {
      const date = new Date(this.dateBirth);
      const formattedDate = formatDate(date, 'yyyy-MM-dd', 'EN');
      return formattedDate;
    }
  }

  public getPhone1(): string {
    return this.phone1;
  }

  public getPhone2(): string {
    return this.phone2;
  }

  public getCvPath(): string {
    return (this.cvPath != null && this.cvPath != '') ? environment.apiUrl + this.cvPath : this.cvPath;
  }

  public getIdCard(): string {
    return (this.idCard != null && this.idCard != '') ? environment.apiUrl + this.idCard : this.idCard;
  }

  public getCity(): string {
    return this.city;
  }

  public getCountry(): string {
    return this.country;
  }

  public getMaritalStatus(): string {
    return this.maritalStatus;
  }

  public getPhoto(): string {
    return this.photo;
  }

  public getVideoPresentation(): string {
    return this.videoPresentation;
  }

  public getTempWorker(): any {
    return this.tempWorker;
  }

  public getDriverLicence(): any {
    return this.driverLicence;
  }

  public getPassport(): any {
    return this.passport;
  }

  public getToken(): string {
    return this.token;
  }

  public getDateCreate(): Date {
    return this.dateCreate;
  }

  public getDateUpdate(): Date {
    return this.dateUpdate;
  }

  public getIsDelete(): boolean {
    return this.isDelete;
  }

  public getCandidatesProfiles(): any[] {
    return this.candidatesProfiles;
  }

  public getCandidatesTrainings(): any[] {
    return this.candidatesTrainings;
  }

  public getCandidatesLanguages(): any[] {
    return this.candidatesLanguages;
  }

  public getCandidatesSkills(): any[] {
    return this.candidatesSkills;
  }

  public getCandidatesCertificates(): any[] {
    return this.candidatesCertificates;
  }

  public getCandidatesExperiences(): any[] {
    return this.candidatesExperiences;
  }

  public getCandidatesJobsAlerts(): any[] {
    return this.candidatesJobsAlerts;
  }

  public getCandidatesJobsApply(): any[] {
    return this.candidatesJobsApply;
  }

  public getCandidatesEducationsAlerts(): any[] {
    return this.candidatesEducationsAlerts;
  }

  public getCandidatesSaveJobs(): Jobs[] {
    return this.candidatesSaveJobs;
  }

}